import styled from 'styled-components';

export const LabelStyled = styled.label`
  font-size: 16px;
  line-height: 175%;
  letter-spacing: 0.15px;
`